import { Component, ElementRef, EventEmitter, Input, OnChanges, Output, SimpleChange, ViewChild } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { Message } from "../../../../../../models/message";
import { Role } from "../../../../../../models/role";
import { RoleStatusMessage } from "../../../../../../models/status-message";
import { MessageControllerService } from "../../../../../../services/message-controller/message-controller.service";
import { RoleStatusService } from "../../../../../../services/role-controller/role-status.service";
import { Store } from "../../../../../../services/store.service";
import { TranslatedBaseError } from "../../../../TranslatedBaseError";
import { TranslateService } from "@ngx-translate/core";
import { MessageEditComponent } from "../../../components/status/section/message-edit.component";

@Component({
  selector: "status-message-list",
  templateUrl: "./status-message-list.component.html",
  providers: [],
})
export class StatusMessageListComponent extends TranslatedBaseError implements OnChanges {

  public serviceId: string;
  public statusMessages: RoleStatusMessage[];
  public allRoles: any[];
  public role: Role;
  public messageType: string;
  public statusType: string;

  @Input() public messageData: any;
  @Input() public messageToEdit: any;

  public message: Message;
  public messages: Message[];

  public topLayer: string = "list";
  public userFilter: any = { subject: "" };

  public roleStatusMessage: RoleStatusMessage;
  public statusMessageFormSubmit = new EventEmitter();
  @Output() public selectItem = new EventEmitter();
  public listToggle: boolean = false;

  public editStatusMessage: boolean = false;
  public editMessage: boolean = false;

  @Output() public editCancel = new EventEmitter();
  public subscription: any;

  // Pagination
  public searchValue: string = "";
  public page: number = 1;
  public pageSize: number = 30;
  public totalPages: number = 1;
  public pageFilter: string = null;
  public sortKey: string = "name";
  public asc: string = "asc";
  public updatePageSender: any;
  public currentChannel: string = "ALL";

  public availableChannels: Array<{ id: string, name: string, disabled?: boolean, icon?: string }> = [
    { id: "ALL", name: "All", disabled: false, icon: "globe" },
    { id: "EMAIL", name: "Email", disabled: false, icon: "envelope" },
    { id: "SMS", name: "SMS", disabled: false, icon: "mobile" },
    { id: "WHATSAPP", name: "WhatsApp", disabled: true, icon: "comments" },
  ];

  @ViewChild(MessageEditComponent) public messageEditComponent: MessageEditComponent;

  constructor(private messageControllerService: MessageControllerService,
    private roleStatusService: RoleStatusService,
    toastr: ToastrService, public store: Store,
    public translateService: TranslateService) {
    super(toastr, translateService);
  }

  public ngOnInit() {
    this.serviceId = this.messageData?.serviceId;
    this.statusMessages = this.messageData?.statusMessages;
    this.allRoles = this.messageData?.allRoles;
    this.role = this.messageData?.role;
    this.messageType = this.messageData?.messageType;
    this.statusType = this.messageData?.statusType;
    this.topLayer = this.messageData?.topLayer ? this.messageData?.topLayer : "list";
    console.log(this.messageData?.data, this.topLayer);
    this.initData();
    this.roleStatusService.updateList.subscribe((event) => {
      console.log(event);
      if (event.update) {
        this.loadServiceMessages();
      }
    });
    if (this.messageToEdit) {
      this.openEditMessage(this.messageToEdit);
    }
  }

  public saveEditMessage() {
    this.messageEditComponent.submit();
  }

  public getMessageIcon(message: Message) {
    switch (message.channel) {
      case "EMAIL":
        return "envelope";
      case "SMS":
        return "mobile";
      case "WHATSAPP":
        return "comments";
      default:
        return "envelope";
    }
  }

  public ngOnChanges(changes: { [propName: string]: SimpleChange }) {
    if (changes.serviceId && changes.serviceId.currentValue) {
      this.serviceId = changes.serviceId.currentValue;
    }
    if (changes.roleStatusMessage && changes.roleStatusMessage.currentValue) {
      this.roleStatusMessage = changes.roleStatusMessage.currentValue;
    }
  }

  public initData() {
    this.loadServiceMessages();
  }

  public filterChannel(channelId: string) {
    this.currentChannel = channelId;
    this.loadServiceMessages(1, this.pageSize, this.pageFilter, this.sortKey, this.asc);
  }

  public updatePage(e: any) {
    if (e && e.trigger === "page") {
      this.page = e.page;
    }
    if (e && e.trigger === "search") {
      this.page = e.page;
      this.pageFilter = e.filter;
    }
    if (e && e.trigger === "sort") {
      this.sortKey = e.sortKey;
      this.asc = e.asc;
    }
    this.loadServiceMessages(this.page, this.pageSize, this.pageFilter, this.sortKey, this.asc);
  }

  public pageNumber() {
    const pages = [];
    let index = 1;
    for (let i = 1; i <= this.totalPages; i++) {
      pages.push(index);
      index++;
    }
    return pages;
  }

  public searchTextChanged(value, emit: boolean = true) {
    this.searchValue = value;
    if (this.updatePageSender) {
      clearTimeout(this.updatePageSender);
    }
    this.updatePageSender = setTimeout(() => {
      this.searchPage();
    }, 2000);
  }

  public setPage(index: number) {
    this.updatePage({ page: index, trigger: "page" });
  }

  public searchPage() {
    const newSearchValue = this.searchValue.replace(/{/g, "%7B").replace(/}/g, "%7D");
    this.updatePage({ page: 1, trigger: "search", filter: newSearchValue });
  }

  public loadServiceMessages(page: number = this.page, size: number = this.pageSize, filter: string = this.pageFilter, sortKey: string = this.sortKey, asc: string = this.asc) {
    this.messages = [];
    this.messageControllerService.getMessagesListByPage((page - 1 > -1 ? page - 1 : 0), size, filter, sortKey, asc, null, (this.currentChannel !== "ALL" ? this.currentChannel : null)).subscribe(
      (data) => {
        this.messages = data.content;
        this.totalPages = data.totalPages;
        if (data.totalElements > data.size) {
          this.page = data.number + 1;
        }
        if (this.messages) {
          if (this.statusMessages && this.statusMessages.length > 0) {
            for (let j = this.statusMessages.length - 1; j >= 0; j--) {
              for (let i = this.messages.length - 1; i >= 0; i--) {
                if (this.messages[i].id === this.statusMessages[j].message.id) {
                  this.messages.splice(i, 1).sort();
                }
              }
            }
          }
          this.messages.sort((a, b) => a.messageType !== this.messageType ? a.subject.toLowerCase() < b.subject.toLowerCase() ? -1 : 1 : 0);
        }
        if (!this.message && this.messages.length > 0) {
          this.message = this.messages[0];
        }
        this.messages.sort((a, b) => {
          const nameA = a.subject.toLowerCase();
          const nameB = b.subject.toLowerCase();
          if (nameA < nameB) {
            return -1;
          }
        });
      },
      (error) => this.showErrorMessageWithTitle("Error HTTP Post Service ", error),
    );
  }

  public openEditMessage(message) {
    this.editMessage = true;
    if (message) {
      this.message = message;
    } else {
      this.message = new Message();
      this.message.name = this.searchValue ? this.searchValue : "";
    }
    this.topLayer = "editMessage";
  }

  public openAddStatus(message) {
    // console.log("--- openAddStatus", message);
    // this.editStatusMessage = true;
    this.message = message;
    // this.topLayer = "editStatusMessage";
    this.selectItem.emit({ message, type: this.messageType, statusType: this.statusType });
  }

  public deleteMessage(message) {
    if (message) {
      this.messageControllerService.deleteMessage(message.id).subscribe(
        (data) => {
          this.responseSuccessful("Message deleted!");
          this.loadServiceMessages();
        },
        (error) => this.showErrorMessageWithTitle("Message delete error!", error),
      );
    }
  }

  public cancelEdit() {
    this.topLayer = "list";
    if (this.messageToEdit) {
      this.closeLayer();
    }
  }

  public formatUsedNum(usages: any) {
    let roles = "";
    usages.forEach((i, index) => {
      if (index > 0) {
        roles += "\n";
      }
      roles += `${i.name}`;
    });
    return roles;
  }

  public resetListSearch() {
    this.searchValue = "";
    this.searchPage();
  }

  public messageWindowSubmitted(event) {
    if (event.save === true) {
      this.message = event.message;
      if (!this.roleStatusMessage) {
        this.roleStatusMessage = new RoleStatusMessage();
      }
      this.roleStatusMessage.message = this.message;
      this.initData();
    } else if (event.save === false) {
      this.initData();
    }
    if (this.messageToEdit) {
      this.openAddStatus(this.message);
    }
  }

  public closeLayer() {
    this.editCancel.emit({ cancel: true });
  }

  public setListView(b) {
    this.listToggle = b;
  }

}
